import { render, staticRenderFns } from "./contractChangeAuditOrdersList.vue?vue&type=template&id=2f7204b0&scoped=true"
import script from "./contractChangeAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./contractChangeAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeAuditOrdersList.vue?vue&type=style&index=0&id=2f7204b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7204b0",
  null
  
)

export default component.exports